/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Page_Meta_DescInputs */

const en_pol_page_meta_desc = /** @type {(inputs: Pol_Page_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Bystep uses AI providers' subscriptions and API keys: allowed, gray area or not allowed, with the date we checked and the source.`)
};

const id_pol_page_meta_desc = /** @type {(inputs: Pol_Page_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara Bystep memakai langganan dan kunci API penyedia AI: diizinkan, abu-abu, atau tidak, lengkap dengan tanggal pengecekan dan sumbernya.`)
};

/**
* | output |
* | --- |
* | "How Bystep uses AI providers' subscriptions and API keys: allowed, gray area or not allowed, with the date we checked and the source." |
*
* @param {Pol_Page_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_page_meta_desc = /** @type {((inputs?: Pol_Page_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Page_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_page_meta_desc(inputs)
	return en_pol_page_meta_desc(inputs)
});